module.exports = __webpack_public_path__ + "static/media/megalake.5cdafaab.svg";